module.exports = __webpack_public_path__ + "img/App-icon-v3.00865773.png";